<template>
  <div class="department_link_card_components">
    <div class="department_link_card">
      <router-link :to="Link">
        <div class="card-main">
          <div class="image">
            <img :src="image" alt="">
          </div>
          <div class="text">
            <p class="catch mincho" v-html="mainCatch">
            </p>
          </div>
        </div>
        <div class="card-ribbon">
          {{title}}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepartmentLinkCard',
  props: {
    Link: String,
    image: String,
    mainCatch: String,
    title: String,
  }
}
</script>

<style scoped lang="scss">
@keyframes move-stripe {
    0% {  background-position-y: 0;  }
    100% {  background-position-y: -80px;  }
}
.department_link_card {
  max-width: 460px;
  width: 100%;
  // height: 260px;
  height: auto;
  position: relative;
  z-index: 0;
  margin-bottom: 10px;
  @media print, screen and (max-width: 460px) {
    max-width: calc(100% - 15px);
  }
  a {
    display: block;
    &:after {
      content: "";
      background: linear-gradient(
      -45deg,
     rgba(100, 100, 100, 0.3) 25%, transparent 25%,
      transparent 50%, rgba(100, 100, 100, 0.3) 50%,
      rgba(100, 100, 100, 0.3) 75%, transparent 75%,
      transparent);
      background-size: 80px 80px;
      width: 100%;
      height: 100%;
      display: block;
      top: 0;
      position: absolute;
      opacity: 0;
    }
    &:hover {
      opacity: 1;
      &:after {
        animation: move-stripe 1.0s infinite linear;
        opacity: 1;
      }
    }
  }
}
.card-main {
  display: flex;
  flex-wrap: nowrap;
  position: relative;
}
.image {
  &:after {
    content: url('../../assets/img/common/icon/circle_arrow_next_pink.svg');
    position: absolute;
    width: 36px;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
    margin-left: -18px;
  }
  img {
    vertical-align: middle;
    width: 160px;
  }
}
.text {
  max-width: 300px;
  flex-basis: 300px;
  width: 100%;
  background-color: #ffce48;
  display: flex;
  align-items: center;
  justify-content: center;
  .catch {
    font-size: 20px;
    line-height: 2em;
    @media print, screen and (max-width: 460px) {
      font-size: 14px;
    }
  }
}
.card-ribbon {
  position: absolute;
  background-color: #e51c57;
  color: #fff;
  font-size: 14px;
  top: 20px;
  right: -15px;
  width: 160px;
  text-align: center;
  @media print, screen and (max-width: 460px) {
    top: 10px;
    line-height: 1.5em;
    width: 100px;
  }
  &:before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left: 15px solid #851c2f;
    position: absolute;
    right: -10px;
    z-index: -1;
    bottom: -10px;
  }
}
</style>
